import React, { useState, useEffect, useRef, useContext } from "react";
import { ButtonGroup, Button, Row } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { C4FStatusContext, ReferenceDataContext } from "../main/App";
import '../css/general.css';
import config from "../etc/config.json";
import CalendarModal from "./CalendarModal";
import moment from 'moment';
import C4FSimpleTable from "../common/C4FSimpleTable";
import { getC4FCodeForCountryCode, getUnicodeFlag } from "../common/Helpers";


function Calendar(props) {
  const navigate = useNavigate();
  const mounted = useRef(false);
  const { handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { countries } = useContext(ReferenceDataContext);
  const [tab, setTab] = useState('races');
  const [races, setRaces] = useState([]);
  const [raceEditions, setRaceEditions] = useState([]);
  const [plannedRaces, setPlannedRaces] = useState([]);
  const [plannedRaceEditions, setPlannedRaceEditions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('Current');
  const [pdfMonth, setPdfMonth] = useState(null);
  const [showCalendarRaceId, setShowCalendarRaceId] = useState(null);
  const [showCalendarRaceType, setShowCalendarRaceType] = useState(null);
  const [showCalendarRaceEditionId, setShowCalendarRaceEditionId] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [refresh, doRefresh] = useState(0);
  const handleCloseCalendar = () => setShowCalendar(false);

  function handleShowCalendar(race) {
    if (mounted.current) {
      setShowCalendarRaceId(race.id);
      setShowCalendarRaceType(race.status === 'Planned' ? 'editor' : 'regular');
      setShowCalendar(true);
    }
  };

  function handleShowCalendarFromEdition(raceEdition) {
    if (mounted.current) {
      setShowCalendarRaceId(raceEdition.race.id);
      setShowCalendarRaceType('regular');
      setShowCalendarRaceEditionId(raceEdition.id);
      setShowCalendar(true);
    }
  };

  function handleSetSelectedMonth(tab, newSelectedMonth) {    
    let raceType = tab === 'races' ? 'race' : 'raceEdition';
    let objects = raceType === 'race' ? races : raceEditions;
    if (!objects.some(r => startsInPeriod(r.startingDate, newSelectedMonth, raceType === 'race' ? r.duration : r.race.duration)))
      loadRaces(
        raceType,
        moment().add(newSelectedMonth, 'months').startOf('month'),
        moment().add(newSelectedMonth, 'months').endOf('month'));
    setSelectedMonth(newSelectedMonth);
    setTab(tab);
    if (newSelectedMonth === 'Current')
      setPdfMonth(null);
    else
      setPdfMonth(moment().add(newSelectedMonth, 'months').format('YYYY-M'));
  }

  function loadRaces(type, from, to) {
    from = from.format('YYYY-MM-DD');
    to = to.format('YYYY-MM-DD');
    if (type === 'race') {
      if (!races.some(r => r.startingDate >= from && r.startingDate <= to))
        handleBackendRequest('GET', '/race', null,
          { context: 'calendar', from: from, to: to },
          function (additionalRaces) {
            if (additionalRaces)
              setRaces(races.concat(additionalRaces));
          });
    }
    else if (type === 'raceEdition') {
      if (!raceEditions.some(r => r.startingDate >= from && r.startingDate <= to))
        handleBackendRequest('GET', '/raceEdition', null,
          { context: 'calendar', from: from, to: to },
          function (additionalRaceEditions) {
            if (additionalRaceEditions)
              setRaceEditions(raceEditions.concat(additionalRaceEditions));
          });      
    }
  }  

  function loadPlannedRaces() {
    handleBackendRequest('GET', '/race', null,
      { context: 'planned' },
      function (loadedPlannedRaces) {        
        if (loadedPlannedRaces) {
          setPlannedRaces(loadedPlannedRaces.map(r => ({ ...r, startingDate: r.raceEditions[0].startingDate })));
          let plannedRaceEditions = [];
          loadedPlannedRaces.forEach(r => 
            r.raceEditions.forEach(re => 
              plannedRaceEditions.push({ ...re, race: { ...r, raceEditions: null } })))
          setPlannedRaceEditions(plannedRaceEditions);
        }
      });   
  }  

  function startsInPeriod(startingDate, month, duration) {
    startingDate = moment(startingDate, 'YYYY-MM-DD');
    let minDate = null, maxDate = null;
    // between yesterday and in 10 days
    if (month === 'Current') {
      minDate = moment().subtract(duration, 'days').startOf('day');
      maxDate = moment().add(10, 'days').startOf('day');
    }
    // otherwise in selected month
    else {
      minDate = moment().add(month, 'months').startOf('month');
      maxDate = moment().add(month, 'months').endOf('month');
    }
    return startingDate >= minDate && startingDate <= maxDate;
  }

  function raceEditionButton(raceEdition) {
    if (raceEdition.race.status === 'Planned')
      return "Planned"
    else if (raceEdition.raceEditionStatus === 'Inscription')
      return "Inscription"
    else if (raceEdition.raceEditionStatus === 'Completed')
      return "Result"
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1 && raceEdition.currentStage === 1)
      return "Finished"
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1)
      return "Startlist"
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted')
      return "Live Race"
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'Completed')
      return "Stage Result"
    else
      return "Live Sprint"
  }

  function showRace(raceEdition) {
    if (raceEdition.race.status === 'Planned')
      return;
    else if (raceEdition.raceEditionStatus === 'Inscription')
      navigate('/inscription');
    else if (raceEdition.raceEditionStatus === 'Completed')
      navigate('/race', { state: { raceEditionId: raceEdition.id } });
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1 && raceEdition.currentStage === 1)
      handleShowCalendarFromEdition(raceEdition);
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted' && raceEdition.currentSector === 1)
      navigate('/race', { state: { raceEditionId: raceEdition.id } });
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'NotStarted')
      navigate('/race', { state: { raceEditionId: raceEdition.id } });
    else if (raceEdition.raceEditionStatus === 'InProgress' && raceEdition.sprintStatus === 'Completed')
      navigate('/race', { state: { raceEditionId: raceEdition.id } });
    else
      navigate('/race', { state: { raceEditionId: raceEdition.id } });
  }

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  useEffect(() => {
    if (races.length === 0) {      
      let from = moment().startOf('month');
      let to = moment().add(1, 'month').endOf('month');
      loadRaces('race', from, to);
      loadRaces('raceEdition', from, to);
      loadPlannedRaces();
    }
  }, []);

  useEffect(() => {
    doRefresh(p => p + 1);
  }, [races, raceEditions]);

  return <>
    <CalendarModal key={'calendar' + showCalendar}
      raceId={showCalendarRaceId}
      selectedRaceEditionId={showCalendarRaceEditionId}
      raceType={showCalendarRaceType}
      show={showCalendar}
      handleClose={handleCloseCalendar} />
    <Row className="my-2 justify-content-center">
      <ButtonGroup>
        <Button variant={(tab === 'races') ? 'primary' : 'outline-primary'}
          onClick={() => {
            handleSetSelectedMonth('races', selectedMonth);
            // setTab('races');
          }}>Races</Button>
        <Button variant={(tab === 'raceEditions') ? 'primary' : 'outline-primary'}
          onClick={() => {
            handleSetSelectedMonth('raceEditions', selectedMonth);
            // setTab('raceEditions');
          }}>Editions</Button>
        {races && plannedRaces && races.concat(plannedRaces)
          .filter(race => race.eventType === 'NationalChampionships')
          .some(race => startsInPeriod(race.startingDate, selectedMonth, race.duration)) ?
          <Button variant={(tab === 'ncs') ? 'primary' : 'outline-primary'}
            onClick={() => {
              handleSetSelectedMonth('ncs', selectedMonth);
              // setTab('ncs');
            }}>NCs</Button>
          : ""
        }
      </ButtonGroup>
    </Row>
    <div className="container-fluid m-0 p-0 justify-content-center">
      <div className="row p-0 m-1 justify-content-center">
        <div className="col p-1 m-1" style={{ maxHeight: 680, maxWidth: 120 }}>
          <h5><u>Select</u></h5>
          <div className="border border-secondary m-0 p-0" style={{ maxHeight: 640, maxWidth: 120, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)', textAlign: "center" }}>
            <div className="btn-group-vertical">
              <Button size="sm" variant={(selectedMonth === "Current") ? 'primary py-0' : 'outline-primary py-0'}
                onClick={() => handleSetSelectedMonth(tab === 'ncs' ? 'races' : tab, 'Current')}>Current</Button><br />
              {[1, 0, -1, -2, -3, -4, -5, -6, -7, -8, -9, -10, -11, -12, -13, -14, -15, -16, -17, -18, -19, -20, -21, -22, -23, -24, -25, -26, -27, -28, -29, -30, -31, -32, -33, -34, -35, -36, -37, -38, -39, -40, -41, -42, -43, -44, -45, -46, -47, -48, -49, -50, -51, -52, -53, -54, -55, -56, -57, -58, -59, -60, -61, -62, -63, -64, -65, -66, -67, -68, -69, -70, -71, -72, -73, -74, -75, -76, -77, -78, -79, -80, -81, -82, -83, -84]
                .map(monthDifference => {
                  const targetDate = new Date(); targetDate.setDate(1); targetDate.setMonth(targetDate.getMonth() + monthDifference);
                  const targetMonth = targetDate.toLocaleString('en-US', { month: 'short' });
                  const targetYear = targetDate.toLocaleString('en-US', { year: 'numeric' });                  
                  return <>
                    <Button size="sm" variant={(selectedMonth === monthDifference) ? 'primary py-0' : 'outline-primary py-0'}
                      onClick={() => handleSetSelectedMonth(tab === 'ncs' ? 'races' : tab, monthDifference)}>{targetMonth}-{targetYear}</Button>
                      {targetMonth === "Jan" ? <br /> : null}                      
                  </>
                })}
            </div>
          </div>
        </div>
        <div className="col p-1 m-1" style={{ maxWidth: 1000, maxHeight: 680 }}>
          <h5><u>Calendar</u></h5>
          <div className="row d-flex p-0 m-0 justify-content-left">
            {(pdfMonth != null) ?
              <p>
                <a href={config.DIR_CALENDARPREVIEW + pdfMonth + "%20Preview%20PDF.pdf"} target="_blank" rel="noreferrer">Preview PDF</a> (available around ~15th of previous month and up for discussion in the <a href={config.FORUM_BASE_URL + 'viewforum.php?f=13'} target="_blank" rel="noreferrer">Forum</a>)
                <br />
                <a href={config.DIR_CALENDARPREVIEW + pdfMonth + "%20Final%20PDF.pdf"} target="_blank" rel="noreferrer">Final PDF</a> (available around ~25th of previous month)
              </p>
              : ""}
          </div>
          {(() => {
            if (tab === 'races') {
              return <C4FSimpleTable key={'races' + refresh}
                initialSortingColumn={'startingDate'}
                initialSortingAscending={true}
                hideFilterButtons={true}
                data={races.concat(plannedRaces)
                  .filter(race => startsInPeriod(race.startingDate, selectedMonth, race.duration))
                  .filter(race => race.eventType !== 'NationalChampionships')
                  .map(race => ({
                    ...race,
                    flag: getUnicodeFlag(race.country),
                    c4fCode: getC4FCodeForCountryCode(countries, race.country),
                    date: moment(race.startingDate).format('dd, D-MMM'),
                    shortDescription: ((race.description.length > 40) ? (race.description.substr(0, 37) + '...') : race.description),
                    raceStatus: race.status === 'Planned' ? (race.stages.some(s => !s.profileCode) ? '✴️ Planned' : '☑️ Designed') : '✅️ Published'
                  }))}
                rowMetadata={[
                  { columnName: 'date', columnDescription: 'Date' },
                  browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'c4fCode', columnDescription: '\u2691', columnType: 'flag' },
                  { columnName: 'raceName', columnDescription: 'Race', cellClickEvent: handleShowCalendar },
                  { columnName: 'shortDescription', columnDescription: 'Description' },
                  { columnName: 'category', columnDescription: 'Cat.' },
                  { columnName: 'duration', columnDescription: 'Days' },
                  { columnName: 'ridersPerTeam', columnDescription: 'Riders' },
                  { columnName: 'raceStatus', columnDescription: 'Status' }
                ]
                }
              />
            }
            else if (tab === 'raceEditions' && raceEditions != null) {
              return <C4FSimpleTable key={'raceEditions' + refresh}
                initialSortingColumn={'startingDate'}
                initialSortingAscending={true}
                data={raceEditions.concat(plannedRaceEditions)
                  .filter(raceEdition => startsInPeriod(raceEdition.startingDate, selectedMonth, raceEdition.race.duration))
                  .filter(raceEdition => raceEdition.race.eventType !== 'NationalChampionships')
                  .map(raceEdition => ({
                    ...raceEdition,
                    flag: getUnicodeFlag(raceEdition.race.country),
                    date: moment(raceEdition.startingDate).format('dd, D-MMM'),
                    nation: getC4FCodeForCountryCode(countries, raceEdition.race.country),
                    raceEditionRaceName: raceEdition.race.raceName,
                    raceEditionCategory: raceEdition.race.category,
                    raceEditionDuration: raceEdition.race.duration,
                    raceEditionRidersPerTeam: raceEdition.race.ridersPerTeam,
                    raceEditionButton: raceEditionButton(raceEdition)
                  }))}
                rowMetadata={[
                  { columnName: 'date', columnDescription: 'Date' },
                  { columnName: 'startingTime', columnDescription: 'Time' },
                  browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'nation', columnDescription: '\u2691', columnType: 'flag' },
                  { columnName: 'raceEditionRaceName', columnDescription: 'Race', cellClickEvent: handleShowCalendarFromEdition },
                  { columnName: 'raceEditionCategory', columnDescription: 'Cat.' },
                  { columnName: 'raceEditionDuration', columnDescription: 'Days' },
                  { columnName: 'raceEditionRidersPerTeam', columnDescription: 'Riders/Team' },
                  { columnName: 'numberOfParticipants', columnDescription: 'Teams' },
                  { columnName: 'raceEditionButton', columnDescription: 'Status', cellClickEvent: showRace }
                ]
                }
              />
            }
            else if (tab === 'ncs' && raceEditions != null) {
              return <C4FSimpleTable key={'nc' + refresh}
                initialSortingColumn={'startingTime'}
                initialSortingAscending={true}
                data={raceEditions.concat(plannedRaceEditions)
                  .filter(raceEdition => raceEdition.race.eventType === 'NationalChampionships')
                  .filter(raceEdition => startsInPeriod(raceEdition.startingDate, selectedMonth, raceEdition.race.duration))
                  .map(raceEdition => ({
                    ...raceEdition,
                    flag: getUnicodeFlag(raceEdition.race.country),
                    date: moment(raceEdition.startingDate).format('dd, D-MMM'),
                    nation: getC4FCodeForCountryCode(countries, raceEdition.race.country),
                    raceEditionRaceName: raceEdition.race.raceName,
                    raceEditionCategory: raceEdition.race.category,
                    raceEditionDuration: raceEdition.race.duration,
                    raceEditionRidersPerTeam: raceEdition.race.ridersPerTeam,
                    raceEditionButton: raceEditionButton(raceEdition)
                  }))}
                rowMetadata={[
                  { columnName: 'date', columnDescription: 'Date' },
                  { columnName: 'startingTime', columnDescription: 'Time' },
                  browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691' }
                    :
                    { columnName: 'nation', columnDescription: '\u2691', columnType: 'flag' },
                  { columnName: 'raceEditionRaceName', columnDescription: 'Race', cellClickEvent: handleShowCalendarFromEdition },
                  { columnName: 'raceEditionCategory', columnDescription: 'Cat.' },
                  { columnName: 'raceEditionDuration', columnDescription: 'Days' },
                  { columnName: 'raceEditionRidersPerTeam', columnDescription: 'Riders/Team' },
                  { columnName: 'numberOfParticipants', columnDescription: 'Teams' },
                  { columnName: 'raceEditionButton', columnDescription: 'Status', cellClickEvent: showRace }
                ]
                }
              />
            }
            else {
              return <></>
            }
          })()}
          <div className="row d-flex p-0 m-1 justify-content-center">                    
            <p>Inscription is only possible for future published races, in case of planned or designed races, please wait for calendar admins to publish them<br></br>
            Visit the <a href={config.FORUM_BASE_URL + 'viewforum.php?f=13'} target="_blank" rel="noreferrer">Forum</a> to find more information, discuss the calendar and help design races.</p>
          </div>
        </div>
      </div>
    </div>

  </>;
}
export default Calendar;